module.exports = __webpack_public_path__ + "static/images/chaping1_eddfddbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/chaping1.png
// module id = 236
// module chunks = 1